import {
  DeleteOutlined,
  EditOutlined,
  LockOutlined,
  PlusCircleOutlined
} from "@ant-design/icons";
import {
  Col,
  Form,
  Input,
  Layout,
  Modal,
  Popconfirm,
  Row,
  Space,
  Spin,
  Tooltip,
  Breadcrumb
} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as PasswordIcon } from "../../image/Password.svg";
import unverifybtn from "../../image/unverify.png";
import verifybtn from "../../image/verifybtn.png";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";
import { authUserData } from "../../utils/Helper";
const { Content } = Layout;
const EmployeeList = () => {

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [manageUserStep, setEmployeeList] = useState([]);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordRecord, setPasswordRecord] = useState(null);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordForm] = Form.useForm();

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  const EmployeeListGetById = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(
        `employee/get-company-employees/`
      );
      if (apiResponse.data.results.success) {
        setEmployeeList(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    EmployeeListGetById();
  }, [reload, state]);

  const handleArchive = async (id) => {
    try {
      let apiResponse = await postRequest("employee-delete/", {
        deleted: [id], 
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - 1; 

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(apiResponse.data.message);
      } else {
        if (Array.isArray(apiResponse.data.message)) {
          ErrorNotificationMsg(apiResponse.data.message.join(", "));
        } else {
          ErrorNotificationMsg(apiResponse.data.message);
        }
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const openPasswordModal = (record) => {
    setPasswordRecord(record);
    setPasswordModalOpen(true);
  };

  const handlePasswordModalAfterOpen = (open) => {
    if (open) {
      passwordForm.resetFields();
    }
  };

  const preventPasswordAutofill = (event) => {
    event.target.removeAttribute("readonly");
  };

  const closePasswordModal = () => {
    setPasswordModalOpen(false);
    setPasswordRecord(null);
    passwordForm.resetFields();
  };

  const handleSetPassword = async (values) => {
    setPasswordLoading(true);
    try {
      const apiResponse = await postRequest("employee-reset-password/", {
        employee_id: passwordRecord?.id,
        password1: values.password,
        password2: values.confirm_password,
      });

      if (apiResponse.data?.success) {
        SuccessNotificationMsg(
          apiResponse.data.message || "Password set successfully"
        );
        closePasswordModal();
        setReload((r) => !r);
      } else {
        ErrorNotificationMsg(
          apiResponse.data?.message || "Failed to set password"
        );
      }
    } catch (error) {
      ErrorNotificationMsg("Failed to set password");
    } finally {
      setPasswordLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          
            <h3>Manage User</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>Manage User</Breadcrumb.Item>
            </Breadcrumb>
            </div>
            <div className="pgnmbtns">
       <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/employee/archive" className="Archiveicon" >
                  <Archiveicon />
                </Link>
              </Tooltip>
            </div>
          
        </div>
      </div>
          <Content className="stepscontentwrap">
           {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
       
            <div className="stepsContent">

              <Spin spinning={loading}>
                <div className="cardswraper">
                  <Row gutter={24}>

                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                      <div className="stepcard addsite">
                        <div>
                          <Link to="/employee/add">
                            <PlusCircleOutlined />
                          </Link>
                          <h5>Add User</h5>
                        </div>
                      </div>
                    </Col>
                    {manageUserStep.map((user) => (
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={user.id}>
                        <div className="stepcard sitecard">
                          <div className="cardtitle ">
                            <div>
                              {user.status === "active" ? (
                                <img src={verifybtn} alt="company" />
                              ) : (
                                <img src={unverifybtn} alt="company" />
                              )}
                              {user.first_name} {user.last_name}

                            </div>
                            <div className="action">
                              <Link to={`/employee/edit/${user.id}`}>
                                <EditOutlined />
                              </Link>
                              <Tooltip title="Set Password">
                                <PasswordIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => openPasswordModal(user)}
                                />
                              </Tooltip>
                              <Popconfirm
                                className="action"
                                title={t("pop_title")}
                                okText={t("pop_ok")}
                                cancelText={t("pop_cancel")}
                                onConfirm={() => handleArchive(user.id)}
                              >
                                <DeleteOutlined />
                              </Popconfirm>
                            </div>
                          </div>
                          <Row gutter={16}>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Employee ID</label>
                                <span className="value">{user.employe_id}</span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Contact Number </label>
                                <span className="value">{user.phone}</span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Role </label>
                                <span className="value">
                                  {user.groups
                                    .map((group) => group.role_name)
                                    .join(", ")}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Email </label>
                                <span className="value">{user.email}</span>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Spin>
            </div>
          </Content>
  
      <Modal
        className="ModelPopupSec"
        title="Set Password"
        open={passwordModalOpen}
        onCancel={closePasswordModal}
        afterOpenChange={handlePasswordModalAfterOpen}
        footer={null}
        destroyOnClose
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        {passwordRecord && (
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handleSetPassword}
          autoComplete="off"
        >
          <Form.Item label="Email">
            <Input
              value={passwordRecord.email || ""}
              disabled
              autoComplete="off"
              readOnly
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: t("val_password") },
              {
                pattern:
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$.=!_%*#:?&])[A-Za-z\d@$.=!_%*#:?&]{8,}$/,
                message: t("passsword_conditions"),
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Enter password"
              autoComplete="new-password"
              readOnly
              onFocus={preventPasswordAutofill}
            />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm the password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const password = getFieldValue("password");
                  if (!value || password === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Confirm password"
              autoComplete="new-password"
              readOnly
              onFocus={preventPasswordAutofill}
            />
          </Form.Item>
          <div className="bottomButtons" style={{ textAlign: "right" }}>
            <Space>
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("cancel")}
                onClick={closePasswordModal}
              />
              <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                htmlType="submit"
                label="Set Password"
                loading={passwordLoading}
              />
            </Space>
          </div>
        </Form>
        )}
      </Modal>
    </>
  );
};

export default EmployeeList;
